import { Controller } from '@hotwired/stimulus'

// Note: This only works if the element is already in the DOM when the
// controller is connected. It doesn't monitor the DOM for changes.
export default class extends Controller {
  static values = {
    selector: String
  }

  connect() {
    this.checkVisibility()
  }

  checkVisibility() {
    if (this.selectorValue && document.querySelector(this.selectorValue)) {
      this.element.classList.remove('d-none')
    } else {
      this.element.classList.add('d-none')
    }
  }
} 
